"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardPlate = void 0;
const react_1 = __importStar(require("react"));
const LinkButton_1 = require("../controls/LinkButton");
const DashboardPlateTitle_1 = require("./components/DashboardPlateTitle/DashboardPlateTitle");
const DashboardPlate_styles_1 = require("./DashboardPlate.styles");
const helpers_1 = require("../helpers");
const Spacer_1 = require("../layouts/Spacer");
const StackView_1 = require("../StackView");
const View_1 = require("../View");
const DashboardPlateContext_1 = require("./context/DashboardPlateContext");
exports.DashboardPlate = (0, helpers_1.createUIElement)('DashboardPlate', (_a, ref) => {
    var { className, title, headerAddon, content, hasViewMore = false, viewMoreIcon, onShowMoreClick, texts, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style, ['data-selector-id']: initialDataSelectorId } = _a, rest = __rest(_a, ["className", "title", "headerAddon", "content", "hasViewMore", "viewMoreIcon", "onShowMoreClick", "texts", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style", 'data-selector-id']);
    const dashboardPlateContext = (0, react_1.useContext)(DashboardPlateContext_1.DashboardPlateContext);
    const uiTexts = (0, react_1.useMemo)(() => (Object.assign({ viewMore: dashboardPlateContext.viewMoreText }, texts)), [dashboardPlateContext.viewMoreText, texts]);
    const dataSelectorId = (0, react_1.useMemo)(() => initialDataSelectorId || 'dashboard-plate', [initialDataSelectorId]);
    const linkButtonIconBefore = (0, react_1.useMemo)(() => viewMoreIcon ||
        dashboardPlateContext.viewMoreIcon ||
        DashboardPlateContext_1.initialContextValue.viewMoreIcon, [dashboardPlateContext.viewMoreIcon, viewMoreIcon]);
    const linkButtonText = (0, react_1.useMemo)(() => uiTexts.viewMore || DashboardPlateContext_1.initialContextValue.viewMoreText, [uiTexts.viewMore]);
    return (react_1.default.createElement(DashboardPlate_styles_1.StyledDashboardPlate, Object.assign({}, rest, { ref: ref, style: style, "data-selector-id": dataSelectorId, direction: StackView_1.STACK_DIRECTION.column, distribution: StackView_1.STACK_DISTRIBUTION.firstFill, spaceHorizontal: View_1.INDENT.m, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, className: (0, helpers_1.cn)('vm-DashboardPlate', className) }),
        react_1.default.createElement(DashboardPlate_styles_1.StyledDashboardPlateHeaderBodyWrapper, { hasViewMore: hasViewMore, direction: StackView_1.STACK_DIRECTION.column, distribution: StackView_1.STACK_DISTRIBUTION.lastFill },
            react_1.default.createElement(DashboardPlate_styles_1.StyledDashboardPlateHeader, { indentLeft: View_1.INDENT.s, gap: StackView_1.STACK_GAP.s, align: StackView_1.STACK_ALIGN.center },
                react_1.default.createElement(DashboardPlateTitle_1.DashboardPlateTitle, { text: title }),
                headerAddon && (react_1.default.createElement(DashboardPlate_styles_1.StyledDashboardPlateHeaderAddonWrapper, null, headerAddon))),
            react_1.default.createElement(DashboardPlate_styles_1.StyledDashboardPlateBody, null, content)),
        hasViewMore && (react_1.default.createElement(DashboardPlate_styles_1.StyledDashboardPlateFooter, null,
            react_1.default.createElement(Spacer_1.Spacer, null),
            react_1.default.createElement(LinkButton_1.LinkButton, { iconBefore: linkButtonIconBefore, onClick: onShowMoreClick }, linkButtonText)))));
});
//# sourceMappingURL=DashboardPlate.js.map